import { useState, useEffect } from "react";
import SECTable from "../../components/SECTable/SECTable";
import rpService from "../rpdesigner/rpService";
import SECDetail from "../../components/SECDetail/SECDetail";
import ProductsRPDesigner from "../rpdesigner/ProductsRPDesigner";
import { globals, getValueInLanguage } from "../../data/messages_new";
import { useKeycloak } from "@react-keycloak/web";
import {
  templatenew,
  componentTemplate,
} from "../rpdesigner/responsePage/rptemplate";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { isAuthorized } from "../../js/globalFunctions";

function Pages({
  helpActive,
  toggleHelp,
  createEnabled,
  handleCreateEnabled,
  addMessage,
  language,
}) {
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [selectedPage, setSelectedPage] = useState(templatenew);
  const [attributes, setAttributes] = useState([]);
  const [deleteId, setDeleteId] = useState();
  const [savedState, setSavedState] = useState({});
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { keycloak } = useKeycloak();
  const isEditAuthorized = isAuthorized(
    keycloak,
    "react_page_edit",
    "service-core"
  );
  const isDeleteAuthorized = isAuthorized(
    keycloak,
    "react_page_delete",
    "service-core"
  );

  const [rows, setRows] = useState([]);
  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "pagename", headerName: "Name", flex: 2 },
    {
      field: "createdAt",
      headerName: "Created at",
      valueGetter: ({ value }) =>
        value && moment(value).format("YYYY-DD-MM hh:mm:ss"),
      flex: 1,
    },
    {
      field: "updatedAt",
      headerName: "Updated at",
      valueGetter: ({ value }) =>
        value && moment(value).format("YYYY-DD-MM hh:mm:ss"),
      flex: 1,
    },
    {
      field: "options",
      headerName: "Options",
      flex: 0.5,
      renderCell: (params) => (
        <>
          {isDeleteAuthorized && (
            <IconButton onClick={(e) => handleDelete(e, params)}>
              <DeleteIcon />
            </IconButton>
          )}
        </>
      ),
    },
  ];

  /* const [open, setOpen] = React.useState(false); */

  /**
   * ***********************************************
   * hooks
   * ***********************************************
   */

  useEffect(() => {
    if (openDetail === false && createEnabled === false) {
      handleLanguageChange("en");
      setSelectedPage(templatenew);
      getData();
      getAttributes();
    }
  }, [openDetail, createEnabled]);

  /**
   * ***********************************************
   * functions
   * ***********************************************
   */

  function getAttributes() {
    rpService.getAttributes(keycloak).then((data) => {
      setAttributes(
        data.map((a, index) => {
          var text = a.attributename;
          if(a.attributedescriptionList){
            text += ' (' + a.attributedescriptionList[0].description + ')';
          }

          return {
            id: index + 1,
            label: a.attributename,
            labelText: text,
            value: "",
          };
        })
      );
    });
  }

  function getData() {
    setLoading(true);
    rpService
      .getPages(keycloak)
      .then((data) => {
        prepareData(data);
      })
      .catch((error) => {
        addMessage(error.message, "error");
        console.log(JSON.stringify(error));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function prepareData(data) {
    setRows(
      data.map((page) => {
        return {
          id: page.pageId,
          ...page,
        };
      })
    );
    setError(null);
  }

  function rowClicked(params) {
    if (isEditAuthorized) {
      handleLanguageChange("en");
      const sPage = rows.filter((p) => p.id === params.id)[0];
      sPage.reactConfig = JSON.parse(sPage.reactConfig);

      //falls neue attribute nachträglich hinzugefügt werden in der config, werden diese bei bestehenden components hinzugefügt!
      sPage.reactConfig.components = sPage.reactConfig.components.map((c) => {
        return {
          ...componentTemplate[c.name],
          ...c,
        };
      });

      setSelectedPage({
        ...sPage,
      });
      setOpenDetail(true);
    }
  }

  function handleCloseDetail() {
    setOpenDetail(false);
    handleCreateEnabled(false);
    setSelectedPage(templatenew);
    setSavedState({});
  }

  function handleCloseDialog() {
    setOpenDialog(false);
    setDeleteId(undefined);
  }

  function getHtmlCode(preview) {
    const redirect = selectedPage.reactConfig.components.filter(
      (c) => c.name === "redirect"
    )[0];
    var rp = "";
    try {
      if (redirect) {
        rp =
          '<meta http-equiv="refresh" content="0; ' +
          redirect.value[0].languages[selectedLanguage] +
          '">';
      } else {
        const noscript = selectedPage.reactConfig.components.filter(
          (c) => c.name === "noscript"
        )[0];
        const noscripttext = noscript?.value[0]?.languages?.[selectedLanguage];

        rp = document.getElementById("responsepage")?.outerHTML;
        rp = rp.replaceAll('id="responsepage"', 'id="responsepagePreview"');
        rp = rp.replaceAll("border: 1px dashed gray;", "");
        rp = rp.replaceAll("border: 1px solid lightgray;", "");
        rp = rp.replaceAll("display: inherit", "display: none");

        rp = rp.replaceAll("hrefx", "href");
        rp = rp.replaceAll("flex: inherit", "flex: auto");

        rp = rp.replaceAll("{noscripttext}", noscripttext ? noscripttext : "please activate javascript to be able to use this site without restrictions")
        if (preview) {
          var found = [], // an array to collect the strings that are found
            rxp = /{([^}]+)}/g,
            curMatch;

          while ((curMatch = rxp.exec(rp))) {
            found.push(curMatch[1]);
          }

          if (found.length > 0) {
            found.forEach((a) => {
              if (a !== "Serial_5") {
                const attr = attributes.find((attr) => attr.label === a);
                if (attr) {
                  rp = rp.replaceAll("{" + a + "}", attr.value);
                }
              }
            });
          }

          rp = rp.replaceAll("{Serial_5}", "12345");
        }
      }
    } catch (e) {}

    return rp;
  }

  function getPageDescriptionList() {
    const htmlcode = getHtmlCode(false);

    var pageDescriptionList = [];
    if (htmlcode !== "") {
      pageDescriptionList.push({
        language: selectedLanguage,
        htmlcode: getHtmlCode(false),
        isDefault: selectedLanguage === "en",
      });
    }

    Object.keys(savedState).forEach((key) => {
      if (key !== selectedLanguage) {
        pageDescriptionList.push({
          language: key,
          htmlcode: savedState[key],
          isDefault: key === "en",
        });
      }
    });

    return pageDescriptionList;
  }

  async function handleSave() {
    var message =
      (createEnabled ? "Created " : "Saved ") +
      ' response page "' +
      selectedPage.pagename +
      '"!';

    if (selectedPage.pagename.trim() === "") {
      message = "Pagename must be filled!";
      addMessage(message, "error");
      return;
    }

//    selectedPage.reactConfig.attributeDetails = attributes;

    var sPage = {
      ...selectedPage,
      reactConfig: JSON.stringify(selectedPage.reactConfig),
      pageDescriptionList: getPageDescriptionList(),
    };
    delete sPage.id;

    try {
      setOpenBackdrop(true);
      if (createEnabled) {
        await rpService.createPage(keycloak, sPage);
      } else {
        await rpService.editPage(keycloak, selectedPage.pageId, sPage);
      }

      handleCreateEnabled(false);
      addMessage(message, "success");
    } catch (error) {
      addMessage(error?.response?.data?.message || error.message, "error");
    }

    setOpenBackdrop(false);
  }

  function handleLanguageChange(val) {
    setSavedState((prev) => {
      const htmlcode = getHtmlCode(false);
      if (htmlcode !== "") {
        return {
          ...prev,
          [selectedLanguage]: htmlcode,
        };
      }
    });
    setSelectedLanguage(val);
  }

  async function handleDeleteConfirmed() {
    try {
      await rpService.deletePage(keycloak, deleteId);

      getData();
      addMessage("Page " + deleteId + " has been deleted!", "success");
    } catch (error) {
      addMessage(error.message, "error");
    }

    setDeleteId(undefined);
    setOpenDialog(false);
  }

  function handleDelete(e, params) {
    e.stopPropagation();

    setDeleteId(params.id);
    setOpenDialog(true);
  }

  /**
   * ***********************************************
   * render
   * ***********************************************
   */

  return (
    <div style={{ padding: "15px" }}>
      <div style={{ height: "40vw", width: "100%" }}>
        <SECTable
          rows={rows}
          columns={columns}
          loading={loading}
          error={error}
          onRowClick={(params) => rowClicked(params)}
        />

        <SECDetail
          open={openDetail}
          openBackdrop={openBackdrop}
          createEnabled={createEnabled}
          handleClose={handleCloseDetail}
          handleSave={handleSave}
          title={getValueInLanguage(globals.products_rpdesigner, language)}
        >
          {
            <ProductsRPDesigner
              helpActive={helpActive}
              toggleHelp={toggleHelp}
              page={selectedPage}
              setPage={setSelectedPage}
              setAttributes={setAttributes}
              attributes={attributes}
              createEnabled={createEnabled}
              selectedLanguage={selectedLanguage}
              setSelectedLanguage={handleLanguageChange}
              getHtmlCode={getHtmlCode}
            />
          }
        </SECDetail>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Do you really want to delete the Page?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteConfirmed}>Yes</Button>
            <Button onClick={handleCloseDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default Pages;
